import { render, staticRenderFns } from "./merchantCommissions.vue?vue&type=template&id=389e1d98"
import script from "./merchantCommissions.vue?vue&type=script&lang=js"
export * from "./merchantCommissions.vue?vue&type=script&lang=js"
import style0 from "./merchantCommissions.vue?vue&type=style&index=0&id=389e1d98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports